
import React from 'react';
import MetricSlider from './MetricSlider';
import { SPIThresholdsContainer, OrDiv, OrBorder } from '../styled';

const KPIMetricList = ({
 selectedKPIConfig, isEditable,
}) => {
  const metrics = ['VideoStartupTimeMilliSec', 'SessionTimeMilliSec', 'TVBitrateKbps', 'TabletBitrateKbps', 'BitrateKbps'];
  const renderFirstMetrcis = () => (
    <SPIThresholdsContainer>
      {
        metrics.map((metricItem => (
          <MetricSlider key={metricItem} isEditable={isEditable} metricKey={metricItem} metricValue={selectedKPIConfig[metricItem]} />
        )))
      }
    </SPIThresholdsContainer>
  );

  const renderSecondMetrics = () => (
    <SPIThresholdsContainer>
      <MetricSlider isEditable={isEditable} metricKey="ConnectionInducedRebufferingRatio" metricValue={selectedKPIConfig.ConnectionInducedRebufferingRatio} />
      <OrDiv>
        <OrBorder />
        <div style={{ margin: '0px 10px' }}> OR </div>
        <OrBorder />
      </OrDiv>
      <MetricSlider isEditable={isEditable} metricKey="ConnectionInducedRebufferingTimeMilliSec" metricValue={selectedKPIConfig.ConnectionInducedRebufferingTimeMilliSec} />
    </SPIThresholdsContainer>
  );

  return (
    <>
      {renderFirstMetrcis()}
      {renderSecondMetrics()}
    </>
  );
};

export default KPIMetricList;
